export const deals = {
  title: 'Deals',
  subtitle: 'Manage business deals and agreements',
  new: 'New deal',
  view: 'Deal details',
  edit: 'Deal edit',
  noDeals: 'No deals',
  fields: {
    type: 'Type',
    customer: 'Customer',
    assignedUser: 'Assigned User',
    date: 'Date',
    followUpDate: 'Follow up date',
    description: 'Description',
    outcome: 'Outcome',
    subject: 'Subject',
    duration: 'Duration',
    status: 'Status',
    minutes: 'Minutes',
    notSet: 'Not set',
    noAssignedUser: 'Not assigned',
    otherOrganization: 'other organization',
  },
  status: {
    completed: 'Completed',
    pending: 'Pending',
    rejected: 'Rejected',
  },
  types: {
    phone: 'Phone',
    email: 'Email',
    sms: 'SMS',
  },
  messages: {
    notSet: 'Not set',
    updated: 'Deal updated successfully',
    created: 'Deal created successfully',
    deleted: 'Deal deleted successfully',
    userAssigned: 'Assigned user successfully updated',
    error: 'Error occurred while creating the deal',
    confirmTitle: 'Deal deletion',
    deleteQuestion: 'Are you sure you want to delete this deal?',
    deleteWarning: 'This action cannot be undone.'
  }
}